var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvertising(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33342 5.33325H1.66675C1.40153 5.33325 1.14718 5.43861 0.959641 5.62615C0.772105 5.81368 0.666748 6.06804 0.666748 6.33325V8.66659C0.666748 8.9318 0.772105 9.18616 0.959641 9.37369C1.14718 9.56123 1.40153 9.66659 1.66675 9.66659H5.33342V5.33325Z",
    fill: "#E61A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5633 1.83858C13.4243 1.74446 13.2637 1.68687 13.0965 1.67114C12.9293 1.65542 12.7609 1.68205 12.6067 1.74858L6 5.12191V9.87858L12.6033 13.2719C12.9226 13.37 13.2678 13.3377 13.5633 13.1819C13.698 13.0901 13.8081 12.9668 13.8842 12.8228C13.9603 12.6787 14.0001 12.5182 14 12.3552V2.66525C14.0001 2.50231 13.9603 2.34182 13.8842 2.19774C13.8081 2.05367 13.698 1.93037 13.5633 1.83858Z",
    fill: "#E61A1A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14_4214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6744 1.0592C14.5353 0.965922 14.3748 0.90886 14.2076 0.893273C14.0404 0.877686 13.8719 0.904075 13.7178 0.970008L7.11108 4.31288V9.02658L13.7144 12.3893C14.0337 12.4865 14.3789 12.4544 14.6744 12.3001C14.809 12.2091 14.9192 12.0869 14.9953 11.9442C15.0714 11.8014 15.1112 11.6424 15.1111 11.4809V1.8784C15.1112 1.71693 15.0714 1.55789 14.9953 1.41511C14.9192 1.27234 14.809 1.15016 14.6744 1.0592Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51682 10.3333H2.82349L3.75682 13.6066C3.81635 13.8161 3.94265 14.0004 4.11653 14.1316C4.29041 14.2628 4.50235 14.3336 4.72015 14.3333H5.33349C5.48575 14.3266 5.63467 14.2864 5.76957 14.2155C5.90447 14.1446 6.022 14.0447 6.11375 13.923C6.2055 13.8013 6.2692 13.6608 6.30027 13.5116C6.33135 13.3624 6.32903 13.2081 6.29349 13.0599L5.51682 10.3333Z",
    fill: "#E61A1A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14_4214",
    x: 5.11108,
    y: -1.11108,
    width: 12,
    height: 15.5557,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14_4214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14_4214",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertising);
export default __webpack_public_path__ + "static/media/advertising.bbc4ccea85a1d594d8c32dd53d1701f4.svg";
export { ForwardRef as ReactComponent };